// extracted by mini-css-extract-plugin
export default {"actionButtons":"ActionButtons_actionButtons__lL4Ov","learnButton":"ActionButtons_learnButton__LNZlH","skipButton":"ActionButtons_skipButton__PAwdh"};